module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/site/site-default/site-default.component.css
// module id = ./src/app/components/calculator/calculator-item/business-calculator/site/site-default/site-default.component.css
// module chunks = main